// @flow
import BoolItem from './BoolItem';

export default BoolItem;
